import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import Autocomplete from '../../uiComponents/input/Autocomplete';
import SubmitButton from '../../uiComponents/input/SubmitButton';
import IApiCaller from '../../infrastructure/api/IApiCaller';
import { Hold } from '../../models/Hold';
import { OpgaveDelopgaver } from '../../models/OpgaveDelopgaver';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { Row, Col, Form, FormControl, Button } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { DropDownFormGroup, MenuItemDto } from '../../uiComponents/input/FormGroups';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { ValidationError, ValidationResult } from '../../infrastructure/ValidationResult';
import { DelopgaveListItem } from '../../models/DelopgaveListItem';
import { ScoreboardKonfiguration } from '../../models/ScoreboardKonfiguration';
import NotificationQueue from '../../uiComponents/layout/NotificationQueue';
import NotificationData from '../../uiComponents/layout/NotificationData';
import { SamletPlacering } from '../../models/SamletPlacering';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { ButtonSection } from '../../uiComponents/layout/ButtonSection';
import { Guid } from '../../infrastructure/Guid';
import { EmptyState } from '../../uiComponents/EmptyState';
import RadioButton from '../../uiComponents/input/RadioButton';
import { OpgaveListItem } from '../../models/OpgaveListItem';
import { OpgavepakkeScoreboardKonfiguration } from '../../models/OpgavepakkeScoreboardKonfiguration';
import { isNullOrUndefined } from '../../infrastructure/ValidationHelper';
import { Spinner } from '../../uiComponents/Spinner';
import { Modal } from '../../uiComponents/layout/Modal';

export interface ScoreboardKonfigurationContainerProps extends RouteComponentProps<any> {
    errorMessages: ValidationError[];
    isSubmitting: boolean;
}

export interface ScoreboardKonfigurationContainerState {
    opgavepakker: OpgavepakkeScoreboardKonfiguration[];
    opgavepakkeOpgaver: OpgaveDelopgaver[];
    holdListe: Hold[];
    scoreboardKonfiguration?: (ScoreboardKonfiguration);
    opgavepakkePlaceringer?: SamletPlacering[];
    alleScoreboardKonfigurationer?: ScoreboardKonfiguration[];
    nykonfigurationNavn: string;
    boardetViser: string;
    opgavepakkeDelopgaver: DelopgaveListItem[];
    validationResult: ValidationResult;
    opgavepakkeHold: Hold[];
    isLoading: boolean;
    konkurrenceId: string;
    showSamletPlacering: boolean;
}

class ScoreboardKonfigurationContainer extends React.Component<ScoreboardKonfigurationContainerProps, ScoreboardKonfigurationContainerState> {
    private apiCaller: IApiCaller;

    constructor(props: ScoreboardKonfigurationContainerProps) {
        super(props);

        this.state = {
            validationResult: new ValidationResult(),
            opgavepakker: new Array<OpgavepakkeScoreboardKonfiguration>(),
            opgavepakkeOpgaver: new Array<OpgaveDelopgaver>(),
            holdListe: new Array<Hold>(),
            scoreboardKonfiguration: undefined,
            alleScoreboardKonfigurationer: undefined,
            nykonfigurationNavn: '',
            boardetViser: 'opgaver',
            opgavepakkeDelopgaver: new Array<DelopgaveListItem>(),
            opgavepakkeHold: new Array<Hold>(),
            isLoading: true,
            konkurrenceId: '',
            showSamletPlacering: false
        };

        this.apiCaller = createApiCaller();
    }

    componentDidMount() {
        let konkurrenceId = this.props.match.params.id;
        this.setState({
            konkurrenceId: konkurrenceId
        });

        this.apiCaller.getOpgavepakkerForScoreboardKonfiguration(konkurrenceId)
            .then(getOpgavepakkerResponse => {
                this.setState({
                    opgavepakker: getOpgavepakkerResponse
                });

                this.apiCaller.GetHoldByKonkurrence(konkurrenceId).then(getHoldResponse => {
                    this.setState({
                        holdListe: getHoldResponse
                    });

                    this.apiCaller.getAllScoreboardKonfigurationer(konkurrenceId).then(getScoreboardkonfigurationerResponse => {
                        if (getScoreboardkonfigurationerResponse.length > 0) {
                            this.setActiveScoreboardKonfiguration(getScoreboardkonfigurationerResponse[0]);
                        }

                        this.setState({
                            alleScoreboardKonfigurationer: getScoreboardkonfigurationerResponse,
                            isLoading: false
                        });
                    });
                });
            });
    }

    createOpgavepakkeItemLists(opgavepakkeId: string, konf?: ScoreboardKonfiguration): void {
        let opgavepakke = this.state.opgavepakker.filter(op => op.id === opgavepakkeId)[0];

        if (opgavepakke !== undefined) {
            let opgavepakkeOpgaver = new Array<OpgaveDelopgaver>();
            let opgavepakkeDelopgaver = new Array<DelopgaveListItem>();
            opgavepakke.opgaveDelopgaver.forEach(opgave => {
                opgavepakkeOpgaver.push(opgave);

                opgave.delopgaver.forEach(delopgave => {
                    let tmpDelopgave = Object.assign({}, delopgave);
                    tmpDelopgave.titel = opgave.titel + ' ' + delopgave.titel;
                    opgavepakkeDelopgaver.push(tmpDelopgave);
                });
            });

            let opgavepakkeHold = this.state.holdListe.filter(h => h.opgavepakkeId === opgavepakkeId);

            if (konf) {
                konf.valgteHold = [];

                opgavepakkeHold.forEach(h =>
                    konf.valgteHold.push(h)
                );

                this.setState({
                    opgavepakkeOpgaver: opgavepakkeOpgaver,
                    opgavepakkeDelopgaver: opgavepakkeDelopgaver,
                    opgavepakkeHold: opgavepakkeHold,
                    scoreboardKonfiguration: konf
                });
            } else {
                this.setState({
                    opgavepakkeOpgaver: opgavepakkeOpgaver,
                    opgavepakkeDelopgaver: opgavepakkeDelopgaver,
                    opgavepakkeHold: opgavepakkeHold
                });
            }
        }
    }

    onOpgavepakkeChanged(valgtOpgavepakkeId: string): void {
        const konf = this.state.scoreboardKonfiguration;
        if (konf !== undefined) {
            konf.valgteOpgavepakkeId = valgtOpgavepakkeId;
            konf.valgteOpgaver = [];
            konf.valgteDelopgaver = [];
        }

        this.createOpgavepakkeItemLists(valgtOpgavepakkeId, konf);

        this.apiCaller.getOpgavepakkePlaceringer(this.state.konkurrenceId, valgtOpgavepakkeId).then(response => {
            this.setState({ opgavepakkePlaceringer: response });
        });
    }

    onOpgaveChanged(fieldName: string, valgteOpgaveIds: string[]): void {
        const valgteOpgaver = this.state.opgavepakkeOpgaver.filter(o => valgteOpgaveIds.indexOf(o.id) >= 0).map(o => {
            const opgave = new OpgaveListItem();
            opgave.id = o.id;
            opgave.opgavepakkeId = o.opgavepakkeId;
            opgave.titel = o.titel;
            return opgave;
        });
        const konf = this.state.scoreboardKonfiguration;
        if (konf !== undefined) {
            konf.valgteOpgaver = valgteOpgaver;
            this.setState({
                scoreboardKonfiguration: konf
            });
        }
    }

    onDelOpgaveChanged(fieldName: string, valgteDelopgaveIds: string[]): void {
        const valgteDelopgaver = this.state.opgavepakkeDelopgaver.filter(o => valgteDelopgaveIds.indexOf(o.id) >= 0);
        const konf = this.state.scoreboardKonfiguration;
        if (konf !== undefined) {
            konf.valgteDelopgaver = valgteDelopgaver;
            this.setState({
                scoreboardKonfiguration: konf
            });
        }
    }

    onHoldItemChanged(e: any, hold: Hold): void {
        const konf = this.state.scoreboardKonfiguration;

        if (konf !== undefined) {
            if (e.target.checked) {
                konf.valgteHold.push(hold);
            } else {
                const holdIndex = konf.valgteHold.map(h => h.id).indexOf(hold.id);
                konf.valgteHold.splice(holdIndex, 1);
            }

            this.setState({
                scoreboardKonfiguration: konf
            });
        }
    }

    saveScoreboardKonfiguration = () => {
        if (this.state.scoreboardKonfiguration === undefined) {
            return;
        }
        if (this.state.scoreboardKonfiguration.id === '00000000-0000-0000-0000-000000000000') {
            const konf = this.state.scoreboardKonfiguration;
            konf.id = Guid.newGuid();
            this.apiCaller.createScoreboardKonfiguration(this.state.scoreboardKonfiguration).then(response => {
                this.setState({ validationResult: response });
                if (response.isValid) {
                    NotificationQueue.push(new NotificationData('Scoreboardkonfiguration blev oprettet', '', 'success'));
                } else {
                    NotificationQueue.push(new NotificationData('Scoreboardkonfiguration blev ikke oprettet', '', 'error'));
                }
            });
        } else {
            this.apiCaller.updateScoreboardKonfiguration(this.state.scoreboardKonfiguration).then(response => {
                this.setState({ validationResult: response });
                if (response.isValid) {
                    NotificationQueue.push(new NotificationData('Scoreboardkonfiguration blev opdateret', '', 'success'));
                } else {
                    NotificationQueue.push(new NotificationData('Scoreboardkonfiguration blev ikke opdateret', '', 'error'));
                }
            });
        }
    }

    getHoldList() {
        const self = this;
        const holdList = this.state.opgavepakkeHold.map((hold, c) => {
            let checked = false;
            if (self.state.scoreboardKonfiguration !== undefined) {
                let valgteHoldIds = self.state.scoreboardKonfiguration.valgteHold.map(v => v.id);
                checked = valgteHoldIds.indexOf(hold.id) >= 0;
            }

            return self.renderDeltager(hold, checked);
        });

        return holdList;
    }

    renderDeltager(hold: Hold, checked: boolean): JSX.Element {
        let placering = '-';
        if (this.state.opgavepakkePlaceringer !== undefined) {
            const placeringForHold = this.state.opgavepakkePlaceringer.filter(p => p.holdId === hold.id)[0];
            if (placeringForHold !== undefined) {
                placering = placeringForHold.placeringValue.toString();
            }
        }

        return (
            <Section key={hold.id} className='konkurrence-afvikling-placering-container'>
                <Row>
                    <Col md={10}>
                        <div>
                            <input type='checkbox' id={hold.id} onChange={(e) => this.onHoldItemChanged(e, hold)} checked={checked} />
                            <label htmlFor={hold.id}> {hold.institution.navn}, {hold.navn}, {hold.opgavepakkeTitel}</label>
                        </div>
                    </Col>
                    <Col md={2}>Placering: {placering}</Col>
                </Row>
            </Section>
        );
    }

    onSelectAllHoldChanged(e: any) {
        const konf = this.state.scoreboardKonfiguration;
        if (konf === undefined) {
            return;
        }

        konf.valgteHold = [];
        if (e.target.checked) {
            this.state.opgavepakkeHold.forEach(h =>
                konf.valgteHold.push(h)
            );
        }

        this.setState({ scoreboardKonfiguration: konf });
    }

    onKonfigurationSelectedChange = (value: any) => {
        if (this.state.alleScoreboardKonfigurationer !== undefined) {
            let konfiguration = this.state.alleScoreboardKonfigurationer.find(x => x.id === value);
            if (konfiguration !== undefined) {
                this.setActiveScoreboardKonfiguration(konfiguration);
            }
        }
    }

    setActiveScoreboardKonfiguration(konf: ScoreboardKonfiguration) {
        let boardetViser = 'opgaver';
        if (konf.valgteDelopgaver.length > 0) {
            boardetViser = 'delopgaver';
        }

        let opgavepakke = this.state.opgavepakker.filter(op => op.id === konf.valgteOpgavepakkeId)[0];
        if (opgavepakke === undefined) {
            konf.valgteOpgaver = new Array<OpgaveListItem>();
            konf.valgteDelopgaver = new Array<DelopgaveListItem>();
            konf.valgteHold = new Array<Hold>();
            konf.valgteOpgavepakkeId = '';
        } else {
            this.createOpgavepakkeItemLists(konf.valgteOpgavepakkeId);
        }

        this.setState({ scoreboardKonfiguration: konf, boardetViser: boardetViser, showSamletPlacering: konf.showSamletPlacering });
    }

    getKonfigurationSelect = (): JSX.Element => {
        let listItems = Array<MenuItemDto>();
        let selectedValue = '';

        if (this.state.alleScoreboardKonfigurationer !== undefined) {
            listItems = this.state.alleScoreboardKonfigurationer.map((k, i) => {
                return new MenuItemDto(k.id, k.navn);
            });
        }

        if (this.state.scoreboardKonfiguration !== undefined) {
            selectedValue = this.state.scoreboardKonfiguration.id;
        } else if (this.state.alleScoreboardKonfigurationer !== undefined && this.state.alleScoreboardKonfigurationer.length > 0) {
            this.setState({ scoreboardKonfiguration: this.state.alleScoreboardKonfigurationer[0] });
        }

        return (
            <div>
                <Row>
                    <Col md={5}>
                        <DropDownFormGroup
                            items={listItems}
                            name='konfiguration'
                            label=''
                            selectedValue={selectedValue}
                            onChange={(fieldName: string, value: any) => this.onKonfigurationSelectedChange(value)}
                            ingenValgtText='Vælg konfiguration'
                        />
                    </Col>
                    <Col md={5}>
                        <FormControl
                            type='text'
                            placeholder='Navn...'
                            name='navn'
                            value={this.state.nykonfigurationNavn}
                            disabled={false}
                            onChange={text => this.setState({ nykonfigurationNavn: text.target.value })}
                        />
                    </Col>
                    <Col md={2}>
                        <Button buttonType='primary' onClick={this.opretKonfiguration} dataDismiss='modal'>Opret ny</Button>
                    </Col>
                </Row>
                <hr />
                <br />
            </div>

        );
    }

    boardetViserChanged(selectedValue: string) {
        let boardetViser = this.state.boardetViser;
        boardetViser = selectedValue;
        if (this.state.scoreboardKonfiguration === undefined) {
            this.setState({ boardetViser: boardetViser });
        } else {
            let konf = this.state.scoreboardKonfiguration;
            konf.valgteDelopgaver = [];
            konf.valgteOpgaver = [];
            this.setState({ boardetViser: boardetViser, scoreboardKonfiguration: konf });
        }
    }

    getOpgavepakkeOpgaveListItems(selectedOpgavepakkeId: string | undefined) {
        if (isNullOrUndefined(selectedOpgavepakkeId)) {
            return new Array<MenuItemDto>();
        } else {
            return this.state.opgavepakkeOpgaver.map(o => new MenuItemDto(o.id, o.titel));
        }
    }

    getOpgavepakkeDelopgaveListItems(selectedOpgavepakkeId: string | undefined) {
        if (isNullOrUndefined(selectedOpgavepakkeId)) {
            return new Array<MenuItemDto>();
        } else {
            return this.state.opgavepakkeDelopgaver.map(d => new MenuItemDto(d.id, d.titel));
        }
    }

    onVisSamletPlaceringChanged = (e: any) => {
        const value = e.target.checked;
        if (this.state.scoreboardKonfiguration !== undefined) {
            this.state.scoreboardKonfiguration.showSamletPlacering = value;
        }
        this.setState({
            showSamletPlacering: value
        });
    }

    renderOpgavePlacering(): JSX.Element {
        if (this.state.alleScoreboardKonfigurationer !== undefined && this.state.alleScoreboardKonfigurationer.length === 0) {
            return <EmptyState header='Der findes ingen konfigurationer for denne konkurrence' subText='Venligst opret en ny konfiguration ovenover' />;
        }

        let opgavepakkerMenuItems: MenuItemDto[] = new Array<MenuItemDto>();
        opgavepakkerMenuItems = this.state.opgavepakker.map(op => new MenuItemDto(op.id, op.titel));

        let valgteDelopgaverMenuItems: MenuItemDto[] = new Array<MenuItemDto>();
        let valgteOpgaverMenuItems: MenuItemDto[] = new Array<MenuItemDto>();
        let valgteOpgavepakkeID: string | undefined;

        if (this.state.scoreboardKonfiguration !== undefined) {
            valgteDelopgaverMenuItems = this.state.scoreboardKonfiguration.valgteDelopgaver.map(d => new MenuItemDto(d.id, d.titel));
            valgteOpgaverMenuItems = this.state.scoreboardKonfiguration.valgteOpgaver.map(d => new MenuItemDto(d.id, d.titel));
            valgteOpgavepakkeID = this.state.scoreboardKonfiguration.valgteOpgavepakkeId;
        }

        let opgaveListItems = this.getOpgavepakkeOpgaveListItems(valgteOpgavepakkeID);
        let delopgaveListItems = this.getOpgavepakkeDelopgaveListItems(valgteOpgavepakkeID);

        return (
            <div className='konkurrence-afvikling-placering-container'>
                <h4>Boardet viser:</h4>
                <Row className='choose-opgave-delopgave'>
                    <Col md={4} className='setting-item-inline'>
                        <DropDownFormGroup
                            errorMessages={this.state.validationResult.errorMessages}
                            items={opgavepakkerMenuItems}
                            name='opgavepakkeValgt'
                            label=''
                            selectedValue={valgteOpgavepakkeID}
                            onChange={(fieldName: string, value: string) => this.onOpgavepakkeChanged(value)}
                            ingenValgtText='Vælg opgavepakke'
                        />
                    </Col>
                    <Col md={2} className='setting-item-inline'>
                        <RadioButton
                            displayText={'Opgaver'}
                            value={'opgaver'}
                            checked={this.state.boardetViser === 'opgaver'}
                            onChange={(selected: string) => { this.boardetViserChanged(selected); }}
                        />
                    </Col>
                    <Col md={2} className='setting-item-inline'>
                        <RadioButton
                            displayText={'Delopgaver'}
                            value={'delopgaver'}
                            checked={this.state.boardetViser === 'delopgaver'}
                            onChange={(selected: string) => { this.boardetViserChanged(selected); }}
                        />
                    </Col>
                    <Col md={2} className='setting-item-inline'>
                        <input type='checkbox' id={'chkVisSamletPlacering'} onChange={this.onVisSamletPlaceringChanged} checked={this.state.showSamletPlacering} />
                        <label className='checkboxLabel' htmlFor={'chkVisSamletPlacering'}>Vis samlet placering</label>
                    </Col>
                </Row>
                <Row>
                    {this.state.boardetViser === 'opgaver' &&
                        <Col md={12}>
                            <Autocomplete
                                errorMessages={this.state.validationResult.errorMessages}
                                label=''
                                name='opgaver'
                                placeholder='Vælg opgave'
                                selected={valgteOpgaverMenuItems}
                                onChange={(fieldName: string, value: any) => this.onOpgaveChanged(fieldName, value)}
                                data={opgaveListItems}
                            />
                        </Col>
                    }

                    {this.state.boardetViser === 'delopgaver' &&
                        <Col md={12}>
                            <Autocomplete
                                errorMessages={this.state.validationResult.errorMessages}
                                label=''
                                name='delopgaver'
                                placeholder='Vælg delopgave'
                                selected={valgteDelopgaverMenuItems}
                                onChange={(fieldName: string, value: any) => this.onDelOpgaveChanged(fieldName, value)}
                                data={delopgaveListItems}
                            />
                        </Col>
                    }

                </Row>
                <SectionGroup className='konkurrence-afvikling-placering-container'>
                    <Section>
                        <Row>
                            <Col md={10}>
                                <input type='checkbox' id='chkSkoleHold' onChange={(e) => this.onSelectAllHoldChanged(e)} />
                                <label htmlFor='chkSkoleHold'>Skole, hold</label>
                            </Col>
                            <Col md={2}>
                                <input type='checkbox' /> Samlet placering
                            </Col>
                        </Row>
                    </Section>
                    {this.getHoldList()}
                </SectionGroup>
            </div>
        );
    }

    opretKonfiguration = () => {
        if (this.state.nykonfigurationNavn === undefined || this.state.nykonfigurationNavn.length === 0) {
            NotificationQueue.push(new NotificationData('Scoreboardkonfiguration kunne ikke oprettes. Venligst angiv navn for konfiguration og prøv igen.', '', 'error'));
            return;
        }

        let konfig = new ScoreboardKonfiguration();
        konfig.id = Guid.empty();
        konfig.konkurrenceId = this.props.match.params.id;
        konfig.navn = this.state.nykonfigurationNavn;
        konfig.valgteDelopgaver = new Array();
        konfig.valgteOpgaver = new Array();
        konfig.valgteHold = new Array();

        let alleKonfigurationer = this.state.alleScoreboardKonfigurationer;
        if (alleKonfigurationer === undefined) {
            alleKonfigurationer = new Array();
        }

        alleKonfigurationer.push(konfig);

        this.setState({
            scoreboardKonfiguration: konfig,
            alleScoreboardKonfigurationer: alleKonfigurationer,
            nykonfigurationNavn: '',
            opgavepakkeHold: []
        });
    }

    getSubmitButton = () => {
        const showDeleteKonfiguration = this.state.scoreboardKonfiguration === undefined || this.state.scoreboardKonfiguration.id === Guid.empty() ? false : true;
        if (this.state.alleScoreboardKonfigurationer !== undefined && this.state.alleScoreboardKonfigurationer.length > 0) {
            return (
                <ButtonSection>
                    <SubmitButton isSubmitting={this.props.isSubmitting}>Gem konfiguration</SubmitButton>
                    {showDeleteKonfiguration && <Button className='btn btn-secondary' dataToggle='modal' dataTarget='#sletKonfigurationModal'>Slet konfiguration</Button>}
                </ButtonSection>
            );
        }

        return undefined;
    }

    getSletKonfigurationModal = () => {
        return (
            <Modal id='sletKonfigurationModal' alert={true} excludeCancel={true} text='Ønsker du at slette denne scoreboardkonfiguration?' >
                <Button buttonType='primary' onClick={() => this.onSletKonfiguration()} dataDismiss='modal'>Slet</Button>
            </Modal>
        );
    }

    onSletKonfiguration = () => {
        if (this.state.scoreboardKonfiguration) {
            this.apiCaller.deleteScoreboardKonfiguration(this.state.scoreboardKonfiguration.id).then(() => {
                NotificationQueue.push(new NotificationData('Scoreboardkonfiguration blev slettet', '', 'success'));
                this.apiCaller.getAllScoreboardKonfigurationer(this.state.konkurrenceId).then(getScoreboardkonfigurationerResponse => {

                    this.setState({
                        alleScoreboardKonfigurationer: getScoreboardkonfigurationerResponse
                    });

                    if (getScoreboardkonfigurationerResponse.length > 0) {
                        this.setActiveScoreboardKonfiguration(getScoreboardkonfigurationerResponse[0]);
                    } else {
                        this.setState({ scoreboardKonfiguration: undefined });
                    }
                });
            });
        }
    }

    render() {
        if (this.state.isLoading) {
            return (
                <Spinner />
            );
        } else {
            return (
                <PageWrapper>
                    <PageTitle title='Scoreboardkonfiguration' />
                    <ContentWrapper>
                        <Form onSubmit={this.saveScoreboardKonfiguration}>
                            <div className='konkurrence-afvikling-placering-container'>
                                {this.getKonfigurationSelect()}
                                {this.renderOpgavePlacering()}
                            </div>
                            {this.getSubmitButton()}
                        </Form>
                    </ContentWrapper>
                    {this.getSletKonfigurationModal()}
                </PageWrapper>
            );
        }
    }
}

export default ScoreboardKonfigurationContainer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/ScoreboardKonfiguration/ScoreboardKonfigurationContainer.tsx